'use strict';
var React = require('react');
var BaseComponent = require('../../shared/base');
var toastr = require('toastr');

var Numeral = require('numeral');
var Currency = require('currency-symbol-map');



class SummaryOrderComponent extends BaseComponent {
    render() {
        {   console.log("Mostrar datos")
            console.log(this.props.orderdata)}
        let format = process.env.MONEY_FORMAT;
        return (
           
                    <div className="row">
                        <div className="col-md-4">
                          {  <table className="cost-table" id="resumen-pedido">
                                <tbody>
                                    <tr>
                                        <th>Resumen de pedido</th>
                                    </tr>
                                    <tr>
                                        <td>Productos: </td>
                                        <td>
                                            <span className="item-price">
                                                <span className="currencySymbol"> {Currency(this.props.orderdata.CurrencyCode)}</span>
                                                <span className="priceAmount"> {Numeral(0).format(format)}</span>
                                            </span>
                                        </td>
                                    </tr>

                                    <tr>
                                        <td>Envío: </td>
                                        <td>
                                            <span className="item-price">
                                                <span className="currencySymbol"> {Currency(this.props.orderdata.CurrencyCode)}</span>
                                                <span className="priceAmount"> {Numeral(0).format(format)}</span>
                                            </span>
                                        </td>
                                    </tr>

                                    <tr>
                                        <td>Subtotal: </td>
                                        <td>
                                            <span className="item-price">
                                                <span className="currencySymbol"> {Currency(this.props.orderdata.CurrencyCode)}</span>
                                                <span className="priceAmount"> {Numeral(this.props.orderdata.SubTotalAmount).format(format)}</span>
                                            </span>
                                        </td>
                                    </tr>
                                    
                                </tbody>
                                <tfoot>
                                    <tr id="div-summary-order" className="divider">
                                        <td colSpan={2} />
                                    </tr>
                                    <tr>
                                        <td>
                                            Total incluye IVA: 
                                        </td>
                                        <td>
                                            <span className="item-price">
                                                <span className="currencySymbol"> {Currency(this.props.orderdata.CurrencyCode)}</span>
                                                <span className="priceAmount"> {Numeral(this.props.orderdata.TotalAmount).format(format)}</span>
                                            </span>
                                        </td>
                                    </tr>
                                </tfoot>
                            </table>}
                        </div>
                        <div className="col-md-12">
                            <div className="spacer-20"></div>
                            
                        </div>
                    </div>
                
        );
    }
}

module.exports = SummaryOrderComponent;